import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { logout } from '../actions/index';
import DashboardRoutes from '../routes/DashboardRutes';
import PageWithMenu from './PageWithMenu';

class DashboardLayout extends React.Component {
  static propTypes = {
    onLogout: PropTypes.func.isRequired,
    profile: PropTypes.object,
    role: PropTypes.string,
  };

  render() {
    const { onLogout, profile, role } = this.props;
    return (
      <PageWithMenu onLogout={onLogout} profile={profile} role={role}>
        <DashboardRoutes {...this.props} />
      </PageWithMenu>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    profile: state.auth.profile,
    role: state.auth.role,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onLogout: () => dispatch(logout()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DashboardLayout));
